import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: #111111;
  color: #eeeeee;
`;
